export default "/assets/images/b257fa9c5ac8c515ac4d77a667ce2943.svg";